export default "__VITE_ASSET__DTH1TJPx__"